import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generarTicketVenta = (venta, config) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, 200] // formato ticket térmico
  });

  const moneda = config.moneda || "Bs";
  const fecha = new Date(venta.fecha).toLocaleString();

  /* =========================
     ENCABEZADO
  ========================== */

  doc.setFontSize(14);
  doc.text(config.nombreNegocio || "Mi Restaurante", 40, 10, {
    align: "center"
  });

  doc.setFontSize(9);
  doc.text(`Fecha: ${fecha}`, 40, 16, { align: "center" });

  const shortID = venta.id.substring(0, 6).toUpperCase();
  doc.text(`Ticket #${shortID}`, 40, 21, { align: "center" });

  doc.line(5, 24, 75, 24);

  /* =========================
     TABLA DE ITEMS
  ========================== */

  const body = venta.items.map(i => [
    i.nombre,
    i.cantidad,
    `${i.precioUnitario.toFixed(2)}`,
    `${i.subtotal.toFixed(2)}`
  ]);

  autoTable(doc, {
    startY: 26,
    head: [["Producto", "Cant", "P.U.", "Sub"]],
    body,
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: 1
    },
    headStyles: {
      fontStyle: "bold"
    },
    columnStyles: {
      0: { cellWidth: 18 },
      1: { halign: "right", cellWidth: 10 },
      2: { halign: "right", cellWidth: 14 },
      3: { halign: "right", cellWidth: 14 }
    }
  });

  /* =========================
     TOTAL
  ========================== */

  const y = doc.lastAutoTable.finalY + 4;

  doc.line(5, y, 75, y);
  doc.setFontSize(11);
  doc.text(
    `TOTAL: ${moneda} ${venta.total.toFixed(2)}`,
    75,
    y + 7,
    { align: "right" }
  );

  doc.setFontSize(9);
  doc.text(
    `Pago: ${venta.metodoPago}`,
    75,
    y + 13,
    { align: "right" }
  );

  /* =========================
     PIE
  ========================== */

  doc.setFontSize(8);
  doc.text("Gracias por su compra", 40, y + 22, { align: "center" });
  doc.text(
    "Sistema POS - devssoft.com",
    40,
    y + 27,
    { align: "center" }
  );

  /* ========================= */

  doc.save(`ticket_${shortID}.pdf`);
};
